/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class PreventiveSheetTemplate {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        } else {
            this.checklist = [];
        }
    }

    /**
     * Finds if there is another check with the same name.
     *
     * @param {PreventiveSheetTemplateCheck} check Check.
     * @return {Boolean} True if there's already another check with the same name.
     */
    findDuplicatedName(check) {
        let duplicated = false;
        for (let i = 0; i < this.checklist.length; i++) {
            if (this.checklist[i].name === check.name) {
                duplicated = true;
                break;
            }
        }
        return duplicated;
    }

    /**
     * Finds if there is another check with the same key.
     *
     * @param {PreventiveSheetTemplateCheck} check Check.
     * @return {Boolean} True if there's already another check with the same key.
     */
    findKeyDuplicated(check) {
        let duplicated = false;
        for (let i = 0; i < this.checklist.length; i++) {
            if (this.checklist[i].key === check.key && check.key !== null) {
                duplicated = true;
                break;
            }
        }
        return duplicated;
    }

    /**
     * Adds a check in this equipment template.
     *
     * @param {PreventiveSheetTemplateCheck} check Check.
     */
    addCheck(check) {
        this.checklist.push(check);
    }

    /**
     * Removes a check from this equipment template.
     *
     * @param {PreventiveSheetFielTemplate} check Check.
     */
    removeCheck(check) {
        const index = this.checklist.indexOf(check);
        if (index > -1) {
            this.checklist.splice(index, 1);
        }
    }
}

export {PreventiveSheetTemplate};



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/PreventiveSheetTemplate.js